import { TEXT_COMPANY_SLOGAN } from "@commons/consts";
import React from "react";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              © {new Date().getFullYear()} 
              {" "} - Powered By {TEXT_COMPANY_SLOGAN}
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
